// builders/sectionMatch.js

const clean = (list) =>
  (list ?? []).map((n) => (n ?? "").toString().trim()).filter(Boolean);

/**
 * SubGroup names a scenario section matches - same rule as the backend
 * (SectionCatalog.SubGroupNamesFor):
 *   1) matchNames computed by the backend (catalog mapping / custom selection / own name)
 *   2) fallback if the backend did not send it: the custom selection (subGroupNames)
 *   3) the section's own name
 *
 * Used by the layout builder AND the Layout Tree, so both always agree on
 * which devices belong to which section.
 */
export function sectionMatchNames(section) {
  if (!section) return [];

  const fromBackend = clean(section.matchNames ?? section.MatchNames);
  if (fromBackend.length) return fromBackend;

  const own = clean(section.subGroupNames ?? section.SubGroupNames);
  if (own.length) return own;

  const name = (section.name ?? section.Name ?? "").toString().trim();
  return name ? [name] : [];
}